import { Store } from '@ngrx/store';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';

// Rxjs
import { Observable } from 'rxjs/Observable';

// Reducer & Actions
import * as fromAuth from '../../../auth/reducers';
import * as fromCore from '../../../core/reducers';
import * as UIActions from '../../../core/actions/ui.actions';
import * as SearchActions from '../../../core/actions/search.actions';
import * as fromMyProjects from '../../../my-projects/reducers';

@Component({
  selector: 'header-bar',
  templateUrl: './header-bar.component.html',
  styleUrls: ['./header-bar.component.scss']
})
export class HeaderBarComponent implements OnInit {

  // Viewchild
  @ViewChild('searchInput') searchInput;

  // Public variables
  public searchForm: FormGroup;
  public projectSelected: any = null;
  public projectDropdownOpened: boolean = false;

  // Observables
  public projecList$: Observable<any>;
  public userLogged$: Observable<string> = this.authStore.select(state => state.auth.login.token);
  public projectView$: Observable<boolean> = this.store.select(state => state.core.ui.projectView);
  public searchOpened$: Observable<boolean> = this.store.select(state => state.core.ui.searchOpened);
  public staff$: Observable<boolean> = this.authStore.select(state => state.auth.login.staff);

  // Constructor
  constructor(
    private store: Store<fromCore.State>,
    private authStore: Store<fromAuth.State>,
    private formBuilder: FormBuilder,
    private projectStore: Store<fromMyProjects.State>
  ) { }

  // On component init
  ngOnInit() {
    // Create form
    this.searchForm = this.formBuilder.group({
      search: ['', Validators.required]
    });

    // Listen for changes
    this.listenForSearch();

    // Get project list
    this.userLogged$.first().subscribe(token => {
      if (token) this.projecList$ = this.projectStore.select(state => (state.myProjects ? state.myProjects.publicProjectList : undefined));
    });
  }

  // Search participants/statements
  private listenForSearch(): void {
    this.searchForm.controls['search']
      .valueChanges
      .subscribe(value => {
        if (!value || value === '') this.resetSearchResults(true);
        else {
          let searchTerms = { search_word: value };
          if (this.projectSelected) searchTerms = Object.assign(searchTerms, { project_id: this.projectSelected.id });

          this.store.dispatch(new SearchActions.SearchForParticipantStatement(searchTerms));
        }
      });
  }

  // Reset search results
  private resetSearchResults(onlyResults = false): void {
    if (!onlyResults) this.searchForm.reset();
    this.store.dispatch(new SearchActions.ResetSearchResults());
  }

  // Start search
  public startSearch(): void {
    this.searchOpened$.first().subscribe(searchOpened => {
      // Dispatch action
      this.store.dispatch(new UIActions.StartSearch());

      // Focus if we need it
      if (!searchOpened) {
        setTimeout(() => { this.searchInput.nativeElement.focus(); }, 300);
      }
      // Reset search results
      else {
        this.resetSearchResults();
        this.projectSelect();
      }
    });
  }

  // Toggle project dropdown
  public toggleProjectDropdown(): void {
    this.projectDropdownOpened = !this.projectDropdownOpened;
  }

  // Select a project
  public projectSelect(project = null): void {
    // Save Project
    this.projectSelected = project;

    // Dispatch reset & close dropdown
    this.resetSearchResults();
    this.projectDropdownOpened = false;
  }

  // Collapse sidebar
  public collapseSidebar(): void {
    this.store.dispatch(new UIActions.CollapseSidebar());
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/header-bar/header-bar.component.ts